// export const url = "http://localhost:4015";


/////live url
// export const url = "http://43.204.79.134:83";
// export const url = "/api";
export const url = "https://paramountinstruments.com/api";

